import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Moment } from 'moment';
import moment from 'moment';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatDatepicker } from '@angular/material/datepicker';
import { Subject, takeUntil, tap } from 'rxjs';

export const YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-year-picker-input',
  templateUrl: './year-picker-input.component.html',
  styleUrls: ['./year-picker-input.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS },
  ],
})
export class YearPickerInputComponent {
  @Input() label: string = 'Ano';
  @Input() start: string = '';
  @Input() required: boolean = false;
  @Output() startChange = new EventEmitter<string>();

  @ViewChild('picker') picker!: MatDatepicker<Moment>;

  yearFormControl: FormControl;
  inputFocused = false;

  private destroy$ = new Subject<void>();

  constructor() {
    this.yearFormControl = new FormControl<Moment | null>(null);
  }

  ngOnInit() {
    if (this.required) {
      this.yearFormControl.setValidators(Validators.required);
    }

    if (this.start) {
      this.yearFormControl.setValue(moment(this.start, 'YYYY'));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['start'] &&
      changes['start'].currentValue !== changes['start'].previousValue
    ) {
      const newValue = changes['start'].currentValue;
      this.yearFormControl.setValue(newValue ? moment(newValue, 'YYYY') : null);
    }
  }

  onYearSelected(selectedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.yearFormControl.setValue(selectedYear);
    this.emitValue();
    datepicker.close();
  }

  openPicker() {
    this.inputFocused = true;
    if (this.picker) {
      this.picker.open();
    }
  }

  closePicker() {
    this.inputFocused = false;
    this.emitValue();
    this.yearFormControl.updateValueAndValidity();

    if (this.picker) {
      this.picker.close();
    }
  }

  private emitValue(): void {
    const value = this.yearFormControl.value;
    const emittedValue = value ? value.format('YYYY') : '';
    this.startChange.emit(emittedValue);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
